import { render, staticRenderFns } from "./button-group.vue?vue&type=template&id=edf7eb5c"
import script from "./button-group.vue?vue&type=script&lang=js"
export * from "./button-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports